import { getDanaGeneralSettings } from "@dana/Store/Context/ContextSelectors";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const DEFAULT_POLL_INTERVAL_MS = 30000;
const DEFAULT_POLL_TIMEOUT_MS = 300000;

const usePollConfig = () => {
    const danaSettings = useAppSelector(getDanaGeneralSettings);
    const pollIntervalMs = danaSettings?.pollIntervalSeconds
        ? danaSettings.pollIntervalSeconds * 1000
        : DEFAULT_POLL_INTERVAL_MS;
    const pollTimeoutMs = danaSettings?.pollTimeoutMinutes
        ? danaSettings.pollTimeoutMinutes * 60 * 1000
        : DEFAULT_POLL_TIMEOUT_MS;
    return { pollIntervalMs, pollTimeoutMs };
};

export default usePollConfig;
